export default __webpack_public_path__ + "static/media/back-top.ad5db25b.svg";